import React from 'react';
import { EditIcon, TrashIcon } from '../../../../images/icons/WrapSvg';
import dragula from 'react-dragula';

// eslint-disable-next-line
import style from './_styles.css';

let moves = true;
let scrollable = true;
let listener = function(e) {
    if (!scrollable) {
        e.preventDefault();
    }
};

class Index extends React.Component {
    constructor(props) {
        super(props);
        moves = !props.alpha;
    }

    state = {
        items: this.props.items,
    };

    UNSAFE_componentWillMount() {
        document.addEventListener('touchmove', listener, { passive: false });
        this.drake = dragula([document.querySelector('.container')], {
            moves: function(el, container, handle) {
                return handle.classList.contains('draggable');
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });

        this.drake = dragula([].slice.apply(document.querySelectorAll('.bloc')), {
            direction: 'horizontal',
            moves: function() {
                return moves;
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        moves = !nextProps.alpha;
        this.setState({ items: nextProps.items });
    }

    componentDidUpdate() {
        this.drake.containers = [].slice.apply(document.querySelectorAll('.bloc'));
    }

    handleEdit = (item) => (event) => {
        this.props.handleEdit(item);
    };

    handleDelete = (item) => (event) => {
        this.props.handleDelete(item);
    };

    drop = (el, target, source, sibling) => {
        scrollable = true;
        this.drake.cancel(true);

        const arr = [...this.state.items];
        const codes = arr.map((f) => f.id);
        const from = codes.indexOf(parseInt(el.id, 10));
        const to = sibling === null ? arr.length : codes.indexOf(parseInt(sibling.id, 10));

        this.props.reorder(from, to);
    };

    render() {
        const Row = (item) => {
            const value = item && item.item ? item.item : {};
            return (
                <div key={value.id} className="flex_full_row rowCatalog bloc hand">
                    <div id={value.id} className="flex_full_row">
                        <div className="flex_full_row">
                            {value.valor}
                        </div>
                        {!!value.puntuacion && 
                            <div className="flex_auto_row margin_left_12">{' [' + value.puntuacion + '%]'} </div>
                        }
                        {value.puntuacion === 0 && 
                            <div className="flex_auto_row margin_left_12">{'[auto]'} </div>
                        }
                        <EditIcon
                            className="hand margin_left_12"
                            style={{ fontSize: 18 }}
                            onClick={this.handleEdit(value)}
                        />
                        <TrashIcon
                            className="hand margin_left_12"
                            style={{ fontSize: 18 }}
                            onClick={this.handleDelete(value)}
                        />
                    </div>
                </div>
            );
        };

        return (
            <div className="container containerBorder" ref={this.dragulaDecorator}>
                {this.state.items.map((item, index) => {
                    return <Row key={item.id} item={item} />;
                })}
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalog/List.js